<template>
  <modal
    :show.sync="showApprovalModal"
    modalContentClasses=""
    modalClasses="modal-alert"
    type="mini"
    @close="closeApprovalReject(false)"
  >
    <div
      class="col-12 pt-4 pb-2"
      :class="{ 'is-invalid': $v.agencyApproval.$error }"
    >
      <div class="text-center">
        <img
          src="~rhomtrip_assets/src/img/icons/alerts/question.png"
          alt="question"
          class="icon-modal"
        />
        <h2 class="modal-title mb-1">
          Partner Approval
        </h2>
      </div>
      <p>How do you want to proceed with the approval?</p>

      <b-form-radio-group
        id="radio-approval"
        v-model="$v.agencyApproval.$model"
        aria-describedby="ariaDescribedby"
        name="radio-optionapproval"
        stacked
        size="md"
      >
        <b-form-radio value="approvalRegister" tabindex="15"
          >Approve as an agency</b-form-radio
        >
        <b-form-radio value="registerAsAgent">Approve as an Agent</b-form-radio>
        <b-form-radio value="rejectRegistration"
          >Reject Registration</b-form-radio
        >
      </b-form-radio-group>

      <small
        class="invalid-feedback text-center"
        v-if="$v.agencyApproval.$error"
        >Select an option</small
      >

      <div class="col-12 mt-3" v-if="agencyApproval === 'registerAsAgent'">
        <WSelect
          v-bind:class="{
            'invalid-feedback': $v.selectAgency.$error
          }"
          v-model="$v.selectAgency.$model"
          label="Agency to associate"
          placeholder="Enter an Agency Name"
          id="agency_name"
          name="agency_name"
          tabindex="3"
          remote
          filterable
          reserve-keyword
          clearable
          :error="
            !$v.selectAgency.minLength || $v.selectAgency.$error
              ? `Select an Agency to associate `
              : ''
          "
        >
          <el-option
            v-for="(agency, index) in agencies"
            :value="agency._id"
            :label="agency.company_name"
            :key="index"
          ></el-option>
        </WSelect>
      </div>
    </div>
    <div
      class="border-top pt-3 text-center col-12 d-flex justify-content-around"
    >
      <base-button
        type="outline-neutral"
        class="min-button "
        @click="closeApprovalReject(false)"
        >Close</base-button
      >

      <base-button
        type="primary"
        class="min-button ml-auto"
        @click.stop="approvalPartner(partnerId)"
        >Accept</base-button
      >
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { CustomersAPI } from "../../../core/api";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "PartnerApproval",
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    partnerId: {
      type: String,
      default: () => null,
      description: "(Reservation Id)"
    },
    agencies: {
      type: Array,
      default: () => [],
      description: "(agencies)"
    }
  },
  data() {
    return {
      agencyApproval: "",
      selectAgency: "",
      showApprovalModal: true
    };
  },
  async created() {
    this.showApprovalModal = this.show;
    this.resetData();
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showApprovalModal = current;
        this.$v.$reset();
      },
      deep: true
    }
  },
  methods: {
    async approvalPartner(partnerId) {
      if (!this.$v.agencyApproval.$invalid && !this.$v.selectAgency.$invalid) {
        if (this.agencyApproval === "approvalRegister") {
          await this.approvalRegister(partnerId);
        } else if (this.agencyApproval === "registerAsAgent") {
          await this.registerAsAgent(partnerId, this.selectAgency);
        } else {
          await this.rejectRegistration(partnerId);
        }
      } else {
        this.$v.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    closeApprovalReject(status) {
      this.showApprovalModal = status;
      this.resetData();
      this.$emit("close", status);
    },
    resetData() {
      this.agencyApproval = "";
      this.selectAgency = "";
      this.$v.$reset();
    },
    partnerApprovedEvent(status) {
      this.$emit("partnerApproved", status);
      this.closeApprovalReject(false);
    },
    async approvalRegister(partnerId) {
      try {
        let { data } = await CustomersAPI.approvalRegister(
          partnerId,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The changes has been saved",
            icon: "flaticon-check-3"
          });
          this.partnerApprovedEvent(true);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The changes couldn't be save, check the Partner data and try again",
            icon: "flaticon-remove"
          });
          this.partnerApprovedEvent(false);
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The changes couldn't be save, check the Partner data and try again",
          icon: "flaticon-remove"
        });
        this.partnerApprovedEvent(false);
      }
    },
    async registerAsAgent(partnerId, agencyToAssign) {
      try {
        let { data } = await CustomersAPI.registerAsAgent(
          partnerId,
          agencyToAssign,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The changes has been saved",
            icon: "flaticon-check-3"
          });
          this.partnerApprovedEvent(true);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The changes couldn't be save, check the Partner data and try again",
            icon: "flaticon-remove"
          });
          this.partnerApprovedEvent(false);
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The changes couldn't be save, check the Partner data and try again",
          icon: "flaticon-remove"
        });
        this.partnerApprovedEvent(false);
      }
    },
    async rejectRegistration(partnerId) {
      try {
        let { data } = await CustomersAPI.rejectRegistration(
          partnerId,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The changes has been saved",
            icon: "flaticon-check-3"
          });
          this.partnerApprovedEvent(true);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The changes couldn't be save, check the Partner data and try again",
            icon: "flaticon-remove"
          });
          this.partnerApprovedEvent(false);
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The changes couldn't be save, check the Partner data and try again",
          icon: "flaticon-remove"
        });
        this.partnerApprovedEvent(false);
      }
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  components: {
    WSelect
  },
  validations: {
    agencyApproval: {
      required
    },
    selectAgency: {
      minLength: minLength(2),
      required: requiredIf(function(value) {
        return this.agencyApproval === "registerAsAgent";
      })
    }
  }
};
</script>
